import { IFormatter } from './FormatterTypes';
import { TEDFormatDefault } from './FormatterClasses/TEDFormatDefault';
import { TEDFormatBool } from './FormatterClasses/TEDFormatBool';
import { TEDFormatInt } from './FormatterClasses/TEDFormatInt';
import { TEDFormatOrgNr } from './FormatterClasses/TEDFormatOrgNr';
import { TEDFormatTelNr } from './FormatterClasses/TEDFormatTelNr';
import { TEDFormatCurr } from './FormatterClasses/TEDFormatCurr';
import { TEDFormatFloat } from './FormatterClasses/TEDFormatFloat';
import { TEDFormatInt64 } from './FormatterClasses/TEDFormatInt64';
import { TEDFormatIntAsDegrees } from './FormatterClasses/TEDFormatIntAsDegrees';
import { TEDFormatIntAsPercent } from './FormatterClasses/TEDFormatIntAsPercent';
import { TEDFormatDateTimeGeneral } from './FormatterClasses/TEDFormatDateTimeGeneral';
import { TEDFormatDate } from './FormatterClasses/TEDFormatDate';
import { TEDFormatDateMonth } from './FormatterClasses/TEDFormatDateMonth';
import { TEDFormatDateYear } from './FormatterClasses/TEDFormatDateYear';
import { TEDFormatDateTimeStr } from './FormatterClasses/TEDFormatDateTimeStr';
import { TEDFormatWeek } from './FormatterClasses/TEDFormatWeek';
import { TEDFormatTime } from './FormatterClasses/TEDFormatTime';
import { TEDFormatTimeMinute } from './FormatterClasses/TEDFormatTimeMinute';
import { TEDFormatTimeHour } from './FormatterClasses/TEDFormatTimeHour';
import { TEDFormatDateTime } from './FormatterClasses/TEDFormatDateTime';
import { TEDFormatDateStr } from './FormatterClasses/TEDFormatDateStr';
import { TEDFormatIntAsYear } from './FormatterClasses/TEDFormatIntAsYear';
import { TEDFormatPersNr } from './FormatterClasses/TEDFormatPersNr';
import { TEDFormatOrgNrPersNr } from './FormatterClasses/TEDFormatOrgNrPersNr';
import { TEDFormatBankgiroNr } from './FormatterClasses/TEDFormatBankgiroNr';
import { TEDFormatPostNr } from './FormatterClasses/TEDFormatPostNr';
import { TEDFormatGroupedNr } from './FormatterClasses/TEDFormatGroupedNr';
import { TEDFormatValues } from './FormatterClasses/TEDFormatValues';
import { TEDFormatMinutes } from './FormatterClasses/TEDFormatMinutes';
import { TEDFormatCase } from './FormatterClasses/TEDFormatCase';
import { TEDMixedType } from '../../Types/GraphQLTypes';
import {
  FormatterType,
  ClientAttributeDataType,
} from '../../Types/ClientModelTypes';

export const FRegisteredFormatters: {
  [key: string]: new (...args: any[]) => IFormatter;
} = {
  TEDFormatBool,
  TEDFormatInt,
  TEDFormatOrgNr,
  TEDFormatTelNr,
  TEDFormatCurr,
  TEDFormatFloat,
  TEDFormatInt64,
  TEDFormatIntAsDegrees,
  TEDFormatIntAsPercent,
  TEDFormatDateTimeGeneral,
  TEDFormatDateTimeStr,
  TEDFormatDate,
  TEDFormatDateMonth,
  TEDFormatDateYear,
  TEDFormatWeek,
  TEDFormatTime,
  TEDFormatTimeMinute,
  TEDFormatTimeHour,
  TEDFormatDateTime,
  TEDFormatDateStr,
  TEDFormatIntAsYear,
  TEDFormatPersNr,
  TEDFormatOrgNrPersNr,
  TEDFormatBankgiroNr,
  TEDFormatPostNr,
  TEDFormatGroupedNr,
  TEDFormatValues,
  TEDFormatMinutes,
  TEDFormatCase,
};

export const findFormatter = (
  formatterType?: FormatterType,
  dataType?: ClientAttributeDataType
): IFormatter => {
  const formatter = formatterType && FRegisteredFormatters[formatterType];

  return formatter ? new formatter() : new TEDFormatDefault(dataType);
};

export const findFormatterForTEDMixed = (
  tedMixedValue?: TEDMixedType | null
) => {
  if (tedMixedValue == null) {
    return findFormatter('');
  }
  switch (tedMixedValue.__typename) {
    case 'TEDMixedCurrency':
    case 'TEDMixedCurrencyArray':
      return findFormatter('TEDFormatCurr');
    case 'TEDMixedFloatArray':
      return findFormatter('TEDFormatFloat');
  }

  return findFormatter('');
};
